import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  VclAccordionModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclFormFieldModule,
  VclTableModule,
  VclAlertModule,
  VclListModule,
  VclDatepickerModule,
  VclSelectModule,
} from '@voxel/community';
import { VoxelFormFieldModule } from '@voxel/mobile';

import { SharedModule } from '../../shared/shared.module';
import { PortalOperatorSummaryComponent } from '../identification/portal-operator-summary/portal-operator-summary.component';
import { AgreementsFilterComponent } from './agreements-filter/agreements-filter.component';
import { DocumentIntroductionComponent } from './document-introduction/document-introduction.component';
import {
  LegalRequirementsCharacteristicsComponent,
} from './legal-requirements-characteristics/legal-requirements-characteristics.component';
import { LegalRequirementsComponent } from './legal-requirements/legal-requirements.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductInfoComponent } from './product-info/product-info.component';
import { ProductSelectionRoutes } from './product-selection.routes';
import { ProductSelectionComponent } from './product-selection/product-selection.component';
import { CaptureDataComponent } from '../capture/capture-data/capture-data.component';
import { SelectedProductDetailComponent } from './selected-product-detail/selected-product-detail.component';

// Multiproduct
import { PrioritizeProductsComponent } from './prioritize-products/prioritize-products.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    ProductSelectionRoutes,
    VoxelFormFieldModule,
    VclTableModule,
    VclCardTemplateModule,
    VclFormFieldModule,
    VclAutocompleteModule,
    VclAlertModule,
    ReactiveFormsModule,
    VclAccordionModule,
    VclListModule,
    VclDatepickerModule,
    VclSelectModule,
  ],
  providers: [],
  declarations: [
    ProductSelectionComponent,
    SelectedProductDetailComponent,
    DocumentIntroductionComponent,
    AgreementsFilterComponent,
    ProductDetailComponent,
    ProductInfoComponent,
    LegalRequirementsComponent,
    LegalRequirementsCharacteristicsComponent,
    PrioritizeProductsComponent,
    PortalOperatorSummaryComponent,
    CaptureDataComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class ProductSelectionModule { }
